var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawerFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2039_981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.40935 20.8892C2.03204 18.8508 1.26074 16.3716 1.26074 13.7272C1.26074 6.45497 7.15565 0.560059 14.483 0.560059C21.8103 0.560059 27.7052 6.45497 27.7052 13.7272C27.7052 20.9994 21.8103 26.8392 14.483 26.8392C11.6732 26.8392 9.0288 25.9577 6.88019 24.4702L1.70148 27.0045L3.18898 22.8726",
    stroke: "#3C3C3B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8847 24.1822C15.596 24.1822 16.1727 23.6055 16.1727 22.8942C16.1727 22.1829 15.596 21.6062 14.8847 21.6062C14.1733 21.6062 13.5967 22.1829 13.5967 22.8942C13.5967 23.6055 14.1733 24.1822 14.8847 24.1822Z",
    fill: "#EE2A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28497 10.0143C8.89297 5.64633 12.589 4.35833 12.589 4.35833C14.157 3.63033 15.781 3.96633 15.781 3.96633C18.189 4.41433 19.477 5.92633 19.981 7.10233C19.981 7.10233 21.045 9.39833 20.037 11.8623C19.869 12.3103 19.589 12.7583 19.253 13.1503C18.693 13.8783 17.965 14.4383 17.181 14.9423L16.789 15.2223C16.677 15.2783 16.565 15.3903 16.509 15.4463C16.341 15.6143 16.117 15.9503 16.117 16.3423V17.8543C16.117 18.0783 16.061 18.3023 15.949 18.5263C15.781 18.8063 15.445 19.1423 14.773 19.1423C14.773 19.1423 13.765 19.0303 13.653 17.5183V16.0063C13.653 15.6143 13.709 15.2223 13.877 14.8303C13.989 14.4943 14.269 14.1023 14.605 13.8783C14.773 13.7663 14.997 13.6543 15.165 13.4863C15.893 12.9823 17.293 11.8623 17.685 11.0223C18.189 9.84633 18.133 8.05433 16.789 7.15833C14.437 5.53433 12.757 7.27033 12.085 8.22233C11.861 8.55833 11.749 8.89433 11.749 9.28633L11.693 10.1263C11.469 11.0223 10.741 11.0223 10.741 11.0223C10.629 11.0223 10.517 11.0223 10.405 11.0223C9.78897 10.9663 9.34097 10.4623 9.34097 9.84633",
    fill: "#EE2A7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2039_981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.700195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerFaq);
export default __webpack_public_path__ + "static/media/drawer-faq.d43929dd.svg";
export { ForwardRef as ReactComponent };